import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import useCountdown from '../hooks/useCountdown';
import DButton from '../../DButton';
const defaultMessage = (secs) => (secs > 0
    ? `Didn't get any code? Resend in: ${secs}s`
    : "Didn't get any code?");
export default function OtpCountdown({ seconds, resendText, message, }) {
    const { secondsLeft, restartCountdown } = useCountdown(seconds);
    return (_jsxs("div", { className: "d-flex gap-2 align-items-center", children: [_jsx("p", { className: "mb-0", children: message ? message(secondsLeft) : defaultMessage(secondsLeft) }), _jsx(DButton, { text: resendText, variant: "link", disabled: secondsLeft > 0, onClick: restartCountdown })] }));
}
//# sourceMappingURL=OtpCountdown.js.map